import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import Switch from "@mui/material/Switch";
import { useSelector } from "react-redux";
import translations from "../assets/locals/translations";

const WhatsAppSelection = ({ showModal, handleCloseModal }) => {
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  const [selectedWhatsApp, setSelectedWhatsApp] = useState("");
  const [initialWhatsApp, setInitialWhatsApp] = useState("");
  const [isWhatsAppEnabled, setIsWhatsAppEnabled] = useState(false);
  const [initialIsWhatsAppEnabled, setInitialIsWhatsAppEnabled] =
    useState(false);

  async function getWhatsappConfig() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/agency/get-config-whatsapp`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response && response.data.isSuccess) {
        const whatsappConfigValue = response.data.result;
        setSelectedWhatsApp(whatsappConfigValue.whatsapp_name);
        setInitialWhatsApp(whatsappConfigValue.whatsapp_name);
        if (whatsappConfigValue.whatsapp_service === "enabled") {
          setIsWhatsAppEnabled(true);
          setInitialIsWhatsAppEnabled(true);
        } else {
          setIsWhatsAppEnabled(false);
          setInitialIsWhatsAppEnabled(false);
        }
      }
    });
  }
  useEffect(() => {
    getWhatsappConfig();
  }, []);

  const handleSwitchChange = (e) => {
    setIsWhatsAppEnabled(e.target.checked);
  };

  const handleCheckboxChange = (e) => {
    const { name } = e.target;
    setSelectedWhatsApp(name);
  };

  const saveChanges = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/agency/update-whatsapp-config`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    let isenabled = isWhatsAppEnabled === true ? "enabled" : "disabled"
    const data = {
      whatsapp_name: selectedWhatsApp,
      whatsapp_service: isenabled
    };

    try {
      const response = await axios.post(url, data, config);
      if (response && response.data.isSuccess) {
        handleCloseModal();
      } else {
      }
    } catch (error) {
      console.error("Error updating WhatsApp config:", error);
    }
  };
  // const isSaveButtonDisabled = selectedWhatsApp === initialWhatsApp;
  const isSaveButtonDisabled =
    selectedWhatsApp === initialWhatsApp &&
    isWhatsAppEnabled === initialIsWhatsAppEnabled;

  return (
    <>
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">{t.selectwhatsappoption || 'Select WhatsApp Option'}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-0">
          <div className="form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="enableSwitch"
              checked={isWhatsAppEnabled}
              onChange={handleSwitchChange}
              style={{
                appearance: "none",
                width: "50px",
                height: "24px",
                backgroundColor: isWhatsAppEnabled ? "#90ee90" : "#ccc",
                borderRadius: "12px",
                position: "relative",
                cursor: "pointer",
                outline: "none",
                transition: "0.3s ease",
              }}
            />
            <label
              className="form-check-label mx-2 mt-1"
              htmlFor="enableSwitch"
            >
              {t.whatsappservice || 'WhatsApp Service'}
            </label>
          </div>
          <hr />
          <form>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="whatsappRC"
                checked={selectedWhatsApp === "whatsappRC"}
                onChange={handleCheckboxChange}
              />
              <label className="form-check-label" htmlFor="whatsappRC">
                {t.whatsappRC || 'WhatsApp RC'}
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="whatsappBK"
                checked={selectedWhatsApp === "whatsappBK"}
                onChange={handleCheckboxChange}
              />
              <label className="form-check-label" htmlFor="whatsappBK">
                {t.whatsappBK || 'WhatsApp BK'}
              </label>
            </div>
          </form>

          <div className="alert alert-info mt-4 p-0">
            <i className="bi bi-info-circle-fill me-2"></i>
            {t.pleaseupdatewhatsappkeys || '*Please update the whatsapp keys after saving the changes.'}
          </div>
        </Modal.Body>
        <Modal.Footer className="m-0 p-1">
          <Button variant="outline-secondary" onClick={handleCloseModal}>
            {t.close || 'Close'}
          </Button>
          <Button
            variant="primary"
            onClick={saveChanges}
            disabled={isSaveButtonDisabled}
          >
            {t.savechanges || 'Save Changes'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WhatsAppSelection;
